import React from 'react';
import PropTypes from 'prop-types';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

const AnimateOnScroll = ({ 
  children, 
  animation = 'animate-fade-in-up',
  delay = 0,
  className = '',
  threshold = 0.1,
  rootMargin = '0px 0px -50px 0px',
  ...props 
}) => {
  const [ref, , hasIntersected] = useIntersectionObserver({
    threshold,
    rootMargin,
  });

  const animationClass = hasIntersected ? animation : '';
  const animationStyle = hasIntersected ? {
    ...(delay > 0 && { animationDelay: `${delay}ms` }),
    animationFillMode: 'both' // Keeps final animation state
  } : {};

  return (
    <div 
      ref={ref} 
      className={`opacity-0 ${animationClass} ${className}`}
      style={animationStyle}
      {...props}
    >
      {children}
    </div>
  );
};

AnimateOnScroll.propTypes = {
  children: PropTypes.node.isRequired,
  animation: PropTypes.string,
  delay: PropTypes.number,
  className: PropTypes.string,
  threshold: PropTypes.number,
  rootMargin: PropTypes.string,
};

export default AnimateOnScroll;